/* Rotas por hash (#/email/m1): funcionam em qualquer hospedagem estática sem regras de reescrita. */
import { useSyncExternalStore } from 'react';

function subscribe(cb: () => void) {
  window.addEventListener('hashchange', cb);
  return () => window.removeEventListener('hashchange', cb);
}

export function useHashRoute(): { view: string; params: string[] } {
  const hash = useSyncExternalStore(subscribe, () => window.location.hash);
  const parts = hash.replace(/^#\/?/, '').split('/').filter(Boolean).map((p) => {
    try { return decodeURIComponent(p); } catch { return p; }
  });
  return { view: parts[0] ?? '', params: parts.slice(1) };
}

/* Atualiza o endereço sem disparar nova navegação (ex.: mensagem selecionada no e-mail). */
export function replaceHash(path: string) {
  history.replaceState(null, '', path);
}
